import { assets } from "@core/assets";

type LogoProps = {
  className?: string;
};

const Logo = ({ className }: LogoProps) => {
  const logo = assets[`logo` as keyof typeof assets] as string;

  return (
    <img
      src={logo}
      alt={`Logo`}
      className={`w-[7.0625rem] h-[2.1875rem] 2xl:w-[10rem] 2xl:h-[3.125rem] ${className}`}
    />
  );
};

export default Logo;
